import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { useModalStore } from '@stores/useModalStore';
import { Spacing, Typography } from 'chatie-design-system';

import Badge, { useBadgePresets } from '@components/common/Badge';

import Modal, { ModalButton, ModalProps } from '../common/Modal';

const containerCSS = (theme: Theme) => css`
  text-align: center;
  line-height: 18px;

  .profile {
    gap: ${Spacing.medium}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${Typography.body14};
    margin-bottom: ${Spacing.small}px;
  }
  p {
    ${Typography.body12};
    color: ${theme.var.gray900};
    line-height: 19px;
  }

  .checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${Spacing.xlarge}px;
  }

  .tip {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.main500};
    ${Typography.body11};
    gap: 6px;
    margin-bottom: ${Spacing.medium}px;
  }
`;

const PopupModal = ({ ...props }: ModalProps) => {
  const { onClose } = props;
  const { t } = useTranslation();
  const { map } = useModalStore();
  const { main } = useBadgePresets();

  const modalMap = map.get(props.name as string);
  const payload = modalMap?.meta as {
    title: string;
    description: string;
    tip: string;
  };

  return (
    <Modal {...props} onClose={onClose} title={payload?.title ?? ''}>
      <div css={containerCSS}>
        <div className="profile" style={{ whiteSpace: 'pre-line' }}>
          {t(payload?.description ?? '')}
        </div>
        <div className="tip">
          {payload?.tip && <Badge {...main} text={t('TIP')} />}
          {t(payload?.tip)}
        </div>

        <ModalButton text={t('확인했어요')} onClick={() => onClose()} />
      </div>
    </Modal>
  );
};

export default PopupModal;
